import script from "./ConstantPage.vue?vue&type=script&lang=js"
export * from "./ConstantPage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__